<!--
 * @Description: 人员审核详情基本信息组件
 * @Author: gaohc
 * @Date: 2022-12-01 11:01:35
-->
<template>
  <div class="baseinfo-wrap">
    <div class="header-wrap" :class="review && isGlobalAdmin && (!review.status || review.status == 2) ? 'sticky' : ''">
      <div class="header" :style="{'align-items' : !isFold && (reviewType == 2 || reviewType == 4 || reviewType == 10) ? 'flex-start' : 'center'}">
        <img class="header-image" src="../../../../assets/instmng/attendantlist/img-attendant-baseinfo.png" alt="" />
        <div style="flex: 1">
          <span>注册信息</span>
          <div v-if="!isFold && review && reviewHistoryFold">
            <div class="review-status-text-wrap">
              <span class="circle-dot" :class="review.status == 2 ? 
              'refuse-status': 'routine-status'">
              </span>
              <span :class="review.status == 2 ? 'refuse-text': 'routine-text'">
                {{review.statusText}}
              </span>
              <span class="more-btn-wrap" v-if="reviewHistoryList && reviewHistoryList.length > 1" 
                @click="reviewHistoryFold = false">
                <span>更多</span>
                <img src="../../../../assets/reviewmng/icon-attendant-review-more.png" alt="">
              </span>
            </div>
            <div class="review-text">
              <div v-if="review.status == 0 || review.status == 3">
                <span>
                  {{review.status == 3 ? '撤回人：' : '提交人：'}}
                </span>
                <span>
                  {{review.submiterText ? review.submiterText : '- -'}}
                </span>
                <span style="margin-left: 35px">
                  {{review.status ==  3 ? '撤回时间：' : '提交时间：'}}
                </span>
                <span>
                  {{review.status ==  3 ? review.cancelTime : review.submitTime}}
                </span>
              </div>
              <div v-else>
                <div style="font-size: 13px">
                  <span>审核意见：</span>
                  <span>{{review.comment ? review.comment : '- -'}}</span>
                </div>
                <p>
                  <span>审核人：</span>
                  <span>{{review.reviewerText ? review.reviewerText : '- -'}}</span>
                  <span style="margin-left: 35px">审核时间：</span>
                  <span>{{review.reviewTime ? review.reviewTime : '- -'}}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="review-history-timeline" v-if="!isFold && !reviewHistoryFold">
            <el-timeline>
              <el-timeline-item
                v-for="(item, index) in reviewHistoryList" size="large"
                :key="index" color="#1BAA60">
                <div class="review-history-text">
                  <div style="display: flex;align-items: center; margin-bottom: 3px;">
                    <span :style="{color: item.reviewStatus == '2' ? '#FF0909' : '#1baa60'}">
                      {{item.reviewStatusText}}
                    </span>
                    <span v-if="index == 0" class="more-btn-wrap" @click="reviewHistoryFold = true">
                      <span>收起</span>
                      <img src="../../../../assets/reviewmng/icon-attendant-review-stow.png" alt="">
                    </span>
                  </div>
                  <div class="review-content-text-wrap">
                    <div v-if="item.reviewStatus == 0 || item.reviewStatus == 3">
                      <span>
                        {{item.reviewStatus == 3 ? '撤回人：' : '提交人：'}}
                      </span>
                      <span v-if="item.reviewStatus == 3">
                        {{item.reviewerText ? item.reviewerText : '- -'}}
                      </span>
                      <span v-else>
                        {{item.submiterText ?  item.submiterText : '- -'}}
                      </span>
                      <span style="margin-left: 35px">
                        {{item.reviewStatus ==  3 ? '撤回时间：' : '提交时间：'}}
                      </span>
                      <span>{{item.time ? item.time : '- -'}}</span>
                    </div>
                    <div v-else>
                      <p style="font-size: 13px;margin: 0;">
                        <span>审核意见：</span>
                        <span>{{item.comment ? item.comment : '- -'}}</span>
                      </p>
                      <p>
                        <span>审核人：</span>
                        <span>{{item.reviewerText ? item.reviewerText : '- -'}}</span>
                        <span style="margin-left: 35px">审核时间：</span>
                        <span>{{item.time ? item.time : '- -'}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </div>
      <div v-if="isFold" @click="isFold = !isFold" class="header-right">
        <img style="width: 20px;height: 15px;margin-right: 5px;"
          src="../../../../assets/instmng/attendantlist/icon-attendant-unfold.png" alt="">
          展开查看
      </div>
      <div v-else-if="!isFold" class="review-btn-container">
        <div v-if="review && isGlobalAdmin && (!review.status || review.status == 2)">
          <span class="status-button adopt-btn" @click="handleReviewAttendant('approve')">
            <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-pass.png"
              alt="" />
            <span style="margin-left: 2px">通 过</span>
          </span>
          <span class="status-button" v-if="!review.status" style="background: #e04a52; cursor: pointer"
            @click="handleReviewAttendant('reject')">
            <img class="review-btn-icon" src="@/assets/reviewmng/icon-attendant-review-list-nopass.png"
              alt=""/>
            <span style="margin-left: 2px">驳 回</span>
          </span>
        </div>
      </div>
    </div>
    <div class="body" v-if="!isFold">
      <div>
        <el-descriptions  :column="1" :labelStyle="labelStyle" :contentStyle="contentStyle">
          <el-descriptions-item label="所属公司">
            {{baseInfo.institutionText ? baseInfo.institutionText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="姓名">
            {{baseInfo.name ? baseInfo.name : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="手机号">
            <span v-if="baseInfo.desensitiseMobile" style="display: flex; align-items: center;">
              <span v-if="phoneNumberVisible">{{baseInfo.desensitiseMobile}}</span>
              <span v-else>{{baseInfo.mobile}}</span>
              <img class="img-phoneNumber" alt="" @click="phoneNumberVisible = !phoneNumberVisible"
                :src="phoneNumberVisible ? require('@/assets/common/icon-common-close-eye.png')
                : require('@/assets/common/icon-common-open-eye.png')" />
            </span>
            <span v-else>- -</span>
          </el-descriptions-item>
          <el-descriptions-item label="身份证号">
            {{baseInfo.desensitiseIdNo ? baseInfo.desensitiseIdNo : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="年龄">
            {{baseInfo.age ? baseInfo.age : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="性别">
            {{baseInfo.genderText ? baseInfo.genderText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="服务地区">
            {{baseInfo.cityText ? baseInfo.cityText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="执业开始时间">
            {{baseInfo.practiceStartDate ? baseInfo.practiceStartDate : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="执业年限">
            {{getSeviceAge}}
          </el-descriptions-item>
          <el-descriptions-item label="护理员等级">
            {{baseInfo.levelText ? baseInfo.levelText : '- -'}}
          </el-descriptions-item>
          <el-descriptions-item label="服务类别">
            {{baseInfo.serviceType == 10 ? '院内陪护' : '- -'}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="idcard-wrap">
        <div>
          <el-image class="idcard-image" :preview-src-list="previewImgList" 
            :src="urlIdCardImg(baseInfo.idCardImg2Path)" fit="contain">
          </el-image>
          <p>身份证头像页</p>  
        </div>
        <div style="margin-top: 30px">
          <el-image class="idcard-image" :preview-src-list="previewImgList" 
          :src="urlIdCardImg(baseInfo.idCardImg1Path)" fit="contain">
          </el-image>
          <p>身份证国徽页</p>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["baseInfo", "reviewType", "review", "reviewHistoryList", "isGlobalAdmin"],

  data() {
    return {
      labelStyle : {'margin-bottom': '10px', 'text-align': 'right', 
        'width': '120px', 'display': 'inline-block', 'color': '#657180'},
      contentStyle : {'margin-bottom': '10px', 'color': '#000'},
      
      isFold: this.reviewType == 2 || this.reviewType == 4 
        || this.reviewType == 10 ? false : true,   //是否折叠页面内容
      reviewHistoryFold: true,   //是否折叠审核记录标识

      phoneNumberVisible: true
    }
  },

  computed: {
    getSeviceAge() {
      if (this.baseInfo && this.baseInfo.practiceStartDate){
        return this.dateUtil.yearsAgoText(this.baseInfo.practiceStartDate, new Date())
      }
    },

    urlIdCardImg() {
      return (imageUrl) =>{
        return this.handleGetTargetUrl(imageUrl);
      }
    },

    previewImgList() {
      let imgList = [];
      if (this.baseInfo.idCardImg2Path) {
        imgList.push(this.handleGetTargetUrl(this.baseInfo.idCardImg2Path));
      }

      if (this.baseInfo.idCardImg1Path) {
        imgList.push(this.handleGetTargetUrl(this.baseInfo.idCardImg1Path));
      }
      return imgList;
    }
  },

  methods: {
    handleGetTargetUrl(url) {
      return url ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, url)
        : '';
    },

    handleReviewAttendant(reviewStatus) { 
      this.$emit("handle-attendant-review", reviewStatus, this.review.version);
    }
  }
};
</script>

<style scoped>
.baseinfo-wrap {
  background: #f7f9fe;
  padding-left: 25px;
  margin: 0 25px 20px 25px;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #f7f9fe;
}

.sticky {
  position: sticky;
  top: 50px;
  z-index: 300;
}

.header {
  margin: 30px 0;
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  color: #000000;
  font-size: 22px;
  flex: 1;
}

.header-image {
  height: 60px;
  width: 60px;
  margin-right: 20px;
}

.header-right {
  background: #F1F5FF;
  height: 120px;
  color: #3E7EF5;
  width: 177px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.review-status-text-wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #1BAA60;
  margin: 10px 0 3px 0;
}

.review-text {
  color: #657180;
  font-size: 14px;
  background: rgba(186,186,186,0.1);
  margin-left: 32px;
  padding: 11px 20px 11px 6px;
  font-weight: 400;
}

.body {
  padding: 5px 260px 0 40px;
  display: flex;
  align-items: flex-start;
}

.baseinfo-wrap /deep/ .el-descriptions__body {
  background: #f7f9fe;
}
.baseinfo-wrap /deep/ .el-descriptions-item__cell {
  padding-bottom: 16px;
}

.idcard-image {
  width: 280px;
  height: 180px;
  background-color: #EBEEF2;
}

.idcard-wrap {
  text-align: center;
}
.idcard-wrap p {
  color: #666666;
  font-size: 13px;
  margin-top: 10px;
}

.drop-icon {
  width: 28px;
  display: inline-block;
  color: #FFFFFF;
  height: 100%;
  background: #66B1FE;
  line-height: 39px;
  text-align: center;
  border-radius: 0px 4px 4px 0px;
}

.review-btn-container {
  padding-right: 20px;
  width: 240px;
  margin-top: 37px;
}
.status-button {
  display: inline-block;
  width: 98px;
  height: 31px;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
}

.review-btn-icon {
  width: 18px;
  height: 20px;
  vertical-align: middle;
}

.adopt-btn {
  background: #3e7ef6;
  cursor: pointer;
  margin-right: 25px;
}

.circle-dot {
  display: inline-block;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  margin-right: 10px;
  color: #999999;
  background: #1BAA60;
}

.more-btn-wrap {
  font-size: 13px;
  font-weight: 400;
  color: #3E7EF6;
  margin-left: 44px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.more-btn-wrap img {
  height: 20px;
  width: 20px;
  margin-left: 5px;
}

.review-history-timeline {
  padding-top: 10px;
}

.review-history-timeline /deep/ .el-timeline {
  padding: 0;
}

.review-history-timeline /deep/ .el-timeline-item__wrapper {
  top: 0;
}

.review-history-timeline /deep/ .el-timeline-item__node--large {
  height: 22px;
  width: 22px;
}

.review-history-timeline /deep/ .el-timeline-item__tail {
  left: 8px;
  border-left: 3px solid #1baa60;
}

.review-history-text {
  font-size: 14px;
  line-height: 20px;
}

.review-content-text-wrap {
  color: #657180;
  font-size: 13px;
  font-weight: 400;
}

.review-content-text-wrap div {
  color: #657180;
  font-size: 14px;
  background: rgba(186,186,186,0.1);
  padding: 11px 20px 11px 6px;
  font-weight: 400;
}

.review-content-text-wrap p,.review-text p {
  margin: 0;
  margin-top: 10px;
  font-size: 14px;
}

.routine-status {
  background: #1BAA60;
}
.refuse-status {
  background: #FF0909;
}

.routine-text {
  color: #1BAA60;
}
.refuse-text {
  color: #FF0909;
}
.img-phoneNumber {
  margin-left: 5px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/review/components/attendantReviewDetails/AttendantReviewBaseInfo.vue